import { AU, audioSetMuted } from './audio';
import { applyQuality } from './quality';
import { S, persist, save } from './state';
import { $, $$ } from './util';

export function seg(id, get, set){ const el = $(id); if (!el) return; el.querySelectorAll('span').forEach(sp => sp.onclick = () => { set(sp.dataset.v); syncSettingsUI(); }); }
export function syncSettingsUI(){
  const st = save.settings;
  for (const id of ['#qualityseg','#qualityseg2']) $$(id+' span').forEach(sp => sp.classList.toggle('sel', sp.dataset.v===st.quality));
  for (const id of ['#soundseg','#soundseg2']) $$(id+' span').forEach(sp => sp.classList.toggle('sel', (sp.dataset.v==='on')===st.sound));
  for (const id of ['#worldseg','#worldseg2']) $$(id+' span').forEach(sp => sp.classList.toggle('sel', sp.dataset.v===(st.world||'photo')));
  $$('#hintseg span').forEach(sp => sp.classList.toggle('sel', (sp.dataset.v==='on')===st.hints));
  for (const id of ['#musicseg','#musicseg2']) $$(id+' span').forEach(sp => sp.classList.toggle('sel', sp.dataset.v===String(st.music)));
  for (const [r,v] of [['#sens','#sensval'],['#sens2','#sensval2']]){ $(r).value = st.sens; $(v).textContent = st.sens.toFixed(1); }
}
export function applySettings(){ const st = save.settings; S.gainHead = st.sens; S.gainHeadY = st.sens*1.08; audioSetMuted(!st.sound); AU.on = st.sound; if (S.quality !== st.quality) applyQuality(st.quality); persist(); }
